var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { createAuthFormHook } from './createAuthFormHook';
export var EForgotPasswordField;
(function (EForgotPasswordField) {
    EForgotPasswordField["EMAIL"] = "email";
})(EForgotPasswordField || (EForgotPasswordField = {}));
var required = fieldValidationMessageIds.required, invalidEmail = fieldValidationMessageIds.invalidEmail;
export var forgotPasswordFormSchema = yup.object((_a = {},
    _a[EForgotPasswordField.EMAIL] = yup
        .string()
        .required(required)
        .email(invalidEmail),
    _a));
export var useForgotPasswordForm = createAuthFormHook(forgotPasswordFormSchema);
